// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"BackDrop__Backdrop__26V0t"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/BackDrop/BackDrop.css
// module id = 97
// module chunks = 0